import { Button, Drawer, IconButton, Text } from '@components'
import { A } from '@solidjs/router'
import { isAuthenticated, useAuth, userId } from '@state'
import {
	ChartArea,
	LayoutDashboard,
	LogOut,
	Megaphone,
	MessageSquare,
	Settings,
	Star,
	UserCircle,
	Waypoints,
} from 'lucide-solid'
import { type Component, Show, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Divider, Grid } from 'styled-system/jsx'
import { grid } from 'styled-system/patterns'
import { Avatar } from '../features/Avatar'
import Popover from '../features/Notifications'
import { DarkMode } from './DarkMode'

export const RouteSelector: Component = (props) => {
	const [isOpen, setIsOpen] = createSignal(false)
	const { logout } = useService(useAuth)()

	return (
		<div class={css({ display: 'flex', gap: '2', alignItems: 'center' })}>
			<Popover />
			<Drawer.Root
				open={isOpen()}
				onOpenChange={({ open }) => setIsOpen(open)}
			>
				<Drawer.Trigger>
					<IconButton variant="subtle">
						<Waypoints />
					</IconButton>
				</Drawer.Trigger>
				<Drawer.Backdrop />
				<Drawer.Positioner width="250px">
					<Drawer.Content>
						<Drawer.Body
							class={grid({
								p: 3,
								alignContent: 'start',
								gridTemplateRows: '1fr auto',
							})}
						>
							<Grid alignContent="start">
								<Grid gridTemplateColumns="1fr 40px">
									<DarkMode />
									<Avatar id={userId()} />
								</Grid>
								<Divider />
								<A href="/">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>Dashboard</Text>
										<LayoutDashboard />
									</Button>
								</A>

								<A href="/setups">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>Setups</Text>
										<ChartArea />
									</Button>
								</A>

								<A href="/chat">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>Chat</Text>
										<MessageSquare />
									</Button>
								</A>

								<A href="/updates">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>Updates</Text>
										<Megaphone />
									</Button>
								</A>

								{/* TODO only show if user is admin or francis */}
								<A href="/potential-high-quality">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>Potential High Quality</Text>
										<Star />
									</Button>
								</A>
							</Grid>

							<Grid>
								<Divider />
								<A href="/settings">
									<Button
										onClick={() => setIsOpen(false)}
										p={2}
										width="100%"
										variant="ghost"
										display="flex"
										justifyContent="space-between"
										alignItems="center"
									>
										<Text>User Settings</Text>
										<Settings size={24} />
									</Button>
								</A>
								<Show
									when={!isAuthenticated()}
									fallback={
										<Button
											onClick={logout}
											p={2}
											width="100%"
											variant="ghost"
											display="flex"
											justifyContent="space-between"
											alignItems="center"
										>
											<Text>Logout</Text>
											<LogOut size={24} />
										</Button>
									}
								>
									<A href="/login">
										<IconButton variant="ghost">
											<UserCircle size={24} />
										</IconButton>
									</A>
								</Show>
							</Grid>
						</Drawer.Body>
					</Drawer.Content>
				</Drawer.Positioner>
			</Drawer.Root>
		</div>
	)
}
